import { Icon, IconProps } from "@chakra-ui/icons";

export default function IconHomeCube(props: IconProps) {
  return (
    <Icon width="3.2rem" height="3.2rem" viewBox="0 0 24 24" {...props}>
      <path d="M6.6 7.9c-4 4-4.6 5.2-3.8 6.7.6 1.1 1.3 2.7 1.6 3.7.4 1.3 1.4 1.7 3.3 1.5 2.3-.2 2.9-.8 3.1-3.6.2-1.7.7-3.2 1.2-3.2s1 1.5 1.2 3.2c.2 2.8.8 3.4 3.1 3.6 1.9.2 2.9-.2 3.3-1.5.3-1 1-2.6 1.6-3.7.8-1.5.2-2.7-3.8-6.7C14.7 5.2 12.3 3 12 3S9.3 5.2 6.6 7.9m10.4.7c2.8 2.9 4 4.8 3.3 5.1S19 15.3 19 16.6c0 1.9-.5 2.4-2.5 2.4-2.2 0-2.5-.4-2.5-3.5 0-2.8-.4-3.5-2-3.5s-2 .7-2 3.5c0 3.1-.3 3.5-2.5 3.5-2 0-2.5-.5-2.5-2.4 0-1.3-.6-2.6-1.2-2.9-.8-.3.4-2.2 3.2-5.1C9.4 6.1 11.7 4 12 4s2.6 2.1 5 4.6" />
    </Icon>
  );
}
